import React, { useState } from "react";
import ArrowUpSvg from "../../assets/taiga-uikit/icons/arrow-up-1.svg?react";
import {
  _colorText,
  _size,
  _sizeText,
  _typeInput,
  _typeLabel,
} from "../../core/core";
import {
  DropdownItem,
  IDropdownItemOption,
} from "../DropdownItem/DropdownItem";
import { Label } from "../texts/label";
import { Text } from "../texts/text";
import "./InputDropdown.css";

interface InputDropdownProps {
  size?: _size;
  type?: _typeInput;
  filled?: "on" | "off";
  labelOutside?: string;
  label?: string;
  description?: string;
  icon?: React.ReactNode;
  rightText?: string;
  selected?: IDropdownItemOption;
  options?: IDropdownItemOption[];
  onSelect?: (option: IDropdownItemOption) => void;
  focusStart?: boolean;
  onBlurHandel?: () => void;
  children?: React.ReactNode;
}

export const InputDropdown: React.FC<InputDropdownProps> = ({
  size = _size.M,
  type = _typeInput.text,
  filled = "off",
  labelOutside,
  label,
  description,
  icon,
  rightText,
  selected,
  options = [],
  onSelect,
  focusStart = false,
  onBlurHandel,
  children,
  ...props
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [selectedOption, setSelectedOption] = useState<
    IDropdownItemOption | undefined
  >(selected);

  const toggleDropdown = (): void => {
    setIsOpen(!isOpen);
  };

  const handleOptionSelect = (option: IDropdownItemOption): void => {
    setSelectedOption(option);
    if (onSelect) onSelect(option);
    setIsOpen(false);
  };

  const variantsClassName = (): string => {
    return `input-field-dropdown input-field-${size}`;
  };

  return (
    <div
      className="field-input-dropdown"
      onClick={toggleDropdown}
      onBlur={onBlurHandel}
    >
      {labelOutside && (
        <Text size={_sizeText.xs} color={_colorText.neutral}>
          {labelOutside}
        </Text>
      )}
      <div className={variantsClassName()}>
        {description && (
          <Text size={_sizeText.xs} color={_colorText.neutral}>
            {description}
          </Text>
        )}
        <div className={`field-dropdown field-arrow-down-${isOpen}`}>
          <div className="field-dropdown-content">
            <div className="field-dropdown-content-left">{children}</div>
            <ArrowUpSvg />
          </div>
          <div className={`field-dropdown-items field-dropdown-open-${isOpen}`}>
            {options.map((option) => (
              <DropdownItem
                key={option.key}
                size={size}
                onClick={() => handleOptionSelect(option)}
                option={option}
              />
            ))}
          </div>
        </div>
        {rightText && (
          <div className="right-content">
            <Text size={_sizeText.xs}>{description}</Text>
          </div>
        )}
      </div>
      {description && (
        <Label size={_size.S} type={_typeLabel.input}>
          {description}
        </Label>
      )}
    </div>
  );
};
